/**
 * @file: formatAiCredits.ts
 * @copyright: (c) 2019-2026 sichuan zhichetech co., ltd.
 */

/** `1234.5` → `1,234.50`; credits always carry 2 decimals. */
export const formatAiCredits = (value: number): string => {
  const [int, frac] = value.toFixed(2).split('.');
  return `${int.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${frac}`;
};
